import React from "react"
import { getImportTypeDefinition } from "utils/dataImportType"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { ImgButton } from "components/image"
import { CustomServerSideReactTable } from "components/utility"
import { deviceTypes, findTypeValueByKey } from "utils/types"
import { GET_DEVICES, DELETE_DEVICE, SUM_DEVICES } from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const BackDeviceContainer = (props) => {
  useBread({ to: props.match.url, name: "設備清單" }, true)

  const fieldsDefinitions = () => {
    return [
      {
        id: "number",
        Header: "編號",
        style: columStyle,
        accessor: "number",
        width: 200,
        // filterable: true,
        filterMethod: (filter, row) => row.number?.includes(filter.value)
      },
      {
        id: "name",
        Header: "名稱",
        style: columStyle,
        accessor: "name",
        width: 200,
        // filterable: true,
        filterMethod: (filter, row) => row.name?.includes(filter.value)
      },
      {
        id: "englishName",
        Header: "英文名稱",
        style: columStyle,
        accessor: "englishName",
        width: 200,
        // filterable: true,
        filterMethod: (filter, row) => row.englishName?.includes(filter.value)
      },
      {
        id: "type",
        Header: "類型",
        style: columStyle,
        accessor: (data) => findTypeValueByKey(deviceTypes, data.type),
        width: 200,
        // filterable: true,
        filterMethod: (filter, row) => row.type?.includes(filter.value)
      },
      {
        id: "description",
        Header: "描述",
        style: columStyle,
        accessor: "description",
        // filterable: true,
        filterMethod: (filter, row) => row.description?.includes(filter.value)
      },
      {
        id: "photoUrl",
        Header: "圖片",
        style: columStyle,
        accessor: "photoUrl",
        width: 60,
        Cell: (cell) => {
          return (
            <div>
              {cell.row.photoUrl && (
                <ImgButton
                  src={`http://${cell.row.photoUrl}`}
                  name={cell.row.name}
                />
              )}
            </div>
          )
        }
      }
    ]
  }

  return (
    <CustomServerSideReactTable
      queryObjectGql={GET_DEVICES}
      sumTotalQueryObjectGql={SUM_DEVICES}
      deleteObjectGql={DELETE_DEVICE}
      objectName="設備"
      objectRoute={props.match.url}
      hasCreateButton={true}
      hasEditButton={true}
      hasDeleteButton={false}
      fieldsDef={fieldsDefinitions()}
      columStyle={columStyle}
      hasUploadButton={true}
      uploadSettings={getImportTypeDefinition("DEVICE")}
    />
  )
}

const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(BackDeviceContainer)
